export var breakpoints = {
    main: '900px',
};
//# sourceMappingURL=breakpoints.js.map